import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "../common/svg-icon";
import ProductImage from "../product-image/product-image";
import _ from "../../utils/translation";
import Price from "../price/price";
import SaveForLaterButton from "../save-for-later-button/save-for-later-button";

function ProductCard({
    designerName,
    freeShipping,
    fullPrice,
    imageAltText,
    imageSize,
    imageUrl,
    inStock,
    isAffiliate,
    leadEnabled,
    leadUrl,
    onSale,
    retailerName,
    salePercentage,
    salePrice,
    productUrl,
    shortDescription,
    hasPromotions,
    isLoggedIn,
    productId,
    currency
}) {
    const image = (
        <ProductImage imageSize={imageSize} imageUrl={imageUrl} imageAltText={imageAltText} />
    );

    return (
        <div className="product-card">
            <div className="product-card__image-wrapper">
                {onSale ? (
                    <span className="product-card__sale-badge">{_("product_card.on_sale")}</span>
                ) : null}
                {isAffiliate && leadEnabled ? (
                    <a href={leadUrl} className="product-card__image-link">
                        {image}
                    </a>
                ) : (
                    <a href={productUrl} className="product-card__image-link">
                        {image}
                    </a>
                )}
            </div>
            <div className="product-card__details">
                <SaveForLaterButton isLoggedIn={isLoggedIn} productId={productId} />
                <a href={productUrl} className="product-card__short-description">
                    <div className="product-card__designer">{designerName}</div>
                    {shortDescription ? (
                        <div className="product-card__short-description-name">
                            {shortDescription}
                        </div>
                    ) : null}
                    <div className="product-card__price-section">
                        {inStock ? (
                            <React.Fragment>
                                {freeShipping && <SVGIcon name="truck" />}
                                {hasPromotions && <SVGIcon name="tag" />}
                                {onSale ? (
                                    <React.Fragment>
                                        <del className="product-card__price">
                                            <Price value={fullPrice} currency={currency} />
                                        </del>
                                        <span className="product-card__price product-card__price--sale">
                                            <Price value={salePrice} currency={currency} />
                                        </span>
                                        <span className="product-card__discount-info">
                                            ({salePercentage}% off)
                                        </span>
                                    </React.Fragment>
                                ) : (
                                    <span className="product-card__price">
                                        <Price value={fullPrice} currency={currency} />
                                    </span>
                                )}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <del className="product-card__price">
                                    <Price value={fullPrice} currency={currency} />
                                </del>
                                <span className="sold-out">{_("product_card.sold_out")}</span>
                            </React.Fragment>
                        )}
                    </div>
                    {isAffiliate && (
                        <div className="product-card__affiliate product-card__affiliate__retailer">
                            <SVGIcon name="hyperlink" />
                            <span>{retailerName}</span>
                        </div>
                    )}
                </a>
            </div>
        </div>
    );
}

ProductCard.propTypes = {
    designerName: PropTypes.string.isRequired,
    freeShipping: PropTypes.bool.isRequired,
    fullPrice: PropTypes.string.isRequired,
    imageSize: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    imageAltText: PropTypes.string,
    inStock: PropTypes.bool.isRequired,
    isAffiliate: PropTypes.bool.isRequired,
    leadEnabled: PropTypes.bool.isRequired,
    leadUrl: PropTypes.string.isRequired,
    onSale: PropTypes.bool.isRequired,
    retailerName: PropTypes.string.isRequired,
    salePercentage: PropTypes.number.isRequired,
    salePrice: PropTypes.string.isRequired,
    productUrl: PropTypes.string.isRequired,
    shortDescription: PropTypes.string.isRequired,
    hasPromotions: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    productId: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired
};

export default ProductCard;

ProductCard.defaultProps = {
    imageAltText: ""
};
